import React from "react";
import { GlobalMenus } from "../../model/menu";
import { PageMetadata } from "../../model/metadata";
import { Col, Row } from "../Grid";
import IsDesktop from "../IsDesktop/IsDesktop";
import MainNav from "./MainNav";
import MinorNav from "./MinorNav";
import styles from "./SiteNav.module.scss";
import GradientLine from "../GradientLine/GradientLine";

interface SiteNavProps {
  menus: GlobalMenus;
  metadata: PageMetadata;
  isErrorPage: boolean;
}

const SiteNav = ({ menus, metadata, isErrorPage }: SiteNavProps) => {
  const { homePage, toolbar } = menus;
  return (
    <header>
      <nav>
        <IsDesktop>
          <Row className={styles.subHeaderRow}>
            <Col className={styles.subHeaderCol}>
              <MinorNav metadata={metadata} />
            </Col>
          </Row>
          <Row className={styles.separatorRow}>
            <GradientLine />
          </Row>
        </IsDesktop>
        <Row className={styles.toolBarRow}>
          <Col className={styles.toolBarCol}>
            <MainNav
              alternates={metadata.alternates}
              homePage={homePage}
              toolbar={toolbar}
              isErrorPage={isErrorPage}
            />
          </Col>
        </Row>
      </nav>
    </header>
  );
};

export default SiteNav;
